export enum ColumnsV1 {
  PATHNAME = 'pathname',
  TITLE = 'title',
  DESCRIPTION = 'description',
  H1 = 'h1',
  BLOCK_TITLES = 'blockTitles',
}

export enum ColumnsV2 {
  PATHNAME = 'pathname',
  TITLE = 'title',
  DESCRIPTION = 'description',
  H1 = 'h1',
  BLOCKS = 'blocks',
}

export interface DataRow {
  [ColumnsV2.PATHNAME]: string
  [ColumnsV2.TITLE]: string
  [ColumnsV2.DESCRIPTION]: string
  [ColumnsV2.H1]: string
  [ColumnsV1.BLOCK_TITLES]: string[]
  [ColumnsV2.BLOCKS]: string
}
